import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal } from "@/lib/motion";

export default function CTA() {
  return (
    <section className="relative py-16 sm:py-20">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] px-8 py-16 sm:px-16 sm:py-20"
            style={{ background: "linear-gradient(135deg, #3D0A6E 0%, #5A189A 55%, #3D0A6E 100%)" }}>
            <div className="pointer-events-none absolute -right-10 -top-10 h-64 w-64 rounded-full" style={{ background: "radial-gradient(closest-side, rgba(227,27,35,0.5), transparent)" }} />
            <div className="pointer-events-none absolute -left-16 bottom-0 h-72 w-72 rounded-full" style={{ background: "radial-gradient(closest-side, rgba(90,24,154,0.6), transparent)" }} />

            <div className="relative z-10 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
              <div>
                <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-medium text-white/90">
                  <Clock size={13} /> Under 60 seconds
                </div>
                <h2 className="font-display text-4xl font-extrabold leading-tight text-white sm:text-5xl">
                  Need shipping today?
                </h2>
                <p className="mt-3 max-w-md text-white/80">
                  Get a quote in under a minute and book your next departure — no account required.
                </p>
              </div>
              <motion.a
                href="#tools"
                data-testid="cta-start-btn"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                className="group inline-flex items-center gap-2 rounded-full bg-[#E31B23] hover:bg-[#B71319] px-8 py-4 text-base font-semibold text-white shadow-[0_16px_40px_-12px_rgba(227,27,35,0.7)]"
              >
                Start Shipping
                <ArrowUpRight size={19} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </motion.a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
